interface Route<T> {
  INTEGRATIONS: {
    CrowdStrike: {
      [key: string]: T
    },
  },
}

const CrowdStrikeRoutes: Route<{ index: string }> = {
  INTEGRATIONS: {
    CrowdStrike: {
      ACTIVITYAPI: {
        index: '/integrations/crowdstrike',
      },
    },
  },
};

const ApiRoutes: Route<string> = {
  INTEGRATIONS: {
    CrowdStrike: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/crowdstrike/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/crowdstrike/checkCredentials',

    },
  },
};

const DocsRoutes: Route<string> = {
  INTEGRATIONS: {
    CrowdStrike: {
      GRAYLOG_CrowdStrike_ACTIVITY_LOG_INPUT: 'integrations/inputs/graylog_crowdstrike_ActivityLog_Input.html#graylog-crowdstrike-activitylog-input',
    },
  },
};

export default CrowdStrikeRoutes;

export { DocsRoutes, ApiRoutes };
